var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkingA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 314.6 466.7",
    style: {
      enableBackground: "new 0 0 314.6 466.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#414042;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:none;stroke:#FFE296;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:#FFE296;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 312.1,
    y1: 90,
    x2: 312.1,
    y2: 161.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 219.2,
    y1: 161.7,
    x2: 312.1,
    y2: 161.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 312.1,
    y1: 161.7,
    x2: 312.1,
    y2: 233.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 219.2,
    y1: 233.4,
    x2: 312.1,
    y2: 233.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 312.1,
    y1: 233.4,
    x2: 312.1,
    y2: 305
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 312.1,
    y1: 305,
    x2: 219.2,
    y2: 305
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-7"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 312.1,
    y1: 305,
    x2: 312.1,
    y2: 376.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-8"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 312.1,
    y1: 376.7,
    x2: 219.2,
    y2: 376.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-9"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 312.1,
    y1: 376.7,
    x2: 312.1,
    y2: 448.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-10"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 312.1,
    y1: 448.4,
    x2: 219.2,
    y2: 448.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 95.4,
    y1: 18.3,
    x2: 2.5,
    y2: 18.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-12"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 18.3,
    x2: 2.5,
    y2: 90
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-13"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 90,
    x2: 95.4,
    y2: 90
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-14"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 90,
    x2: 2.5,
    y2: 161.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 95.4,
    y1: 161.7,
    x2: 2.5,
    y2: 161.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-16"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 161.7,
    x2: 2.5,
    y2: 233.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-17"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 95.4,
    y1: 233.4,
    x2: 2.5,
    y2: 233.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 233.4,
    x2: 2.5,
    y2: 305
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 305,
    x2: 95.4,
    y2: 305
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 305,
    x2: 2.5,
    y2: 376.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 95.4,
    y1: 376.7,
    x2: 2.5,
    y2: 376.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-22"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 376.7,
    x2: 2.5,
    y2: 448.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-23"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 448.4,
    x2: 95.4,
    y2: 448.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE-24"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "219.2,18.3 312.1,18.3 312.1,90 219.2,90  "
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 157.3,
    y1: 18.3,
    x2: 157.3,
    y2: 77.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 157.3,
    y1: 130.9,
    x2: 157.3,
    y2: 192.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 157.3,
    y1: 274.2,
    x2: 157.3,
    y2: 335.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 157.3,
    y1: 394.6,
    x2: 157.3,
    y2: 446.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.4,31.2h3.8c1.1,0,2,0.9,2,2v41.9c0,1.1-0.9,1.9-2,1.9h-3.8c-1.1,0-1.9-0.9-1.9-1.9V33.2 C11.4,32.1,12.3,31.2,13.4,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.4,102.9h3.8c1.1,0,2,0.9,2,1.9v41.9c0,1.1-0.9,1.9-2,1.9h-3.8c-1.1,0-1.9-0.9-1.9-1.9v-41.9 C11.4,103.8,12.3,102.9,13.4,102.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.4,174.6h3.8c1.1,0,2,0.9,2,1.9v41.9c0,1.1-0.9,1.9-2,1.9h-3.8c-1.1,0-1.9-0.9-1.9-1.9v-41.9 C11.4,175.5,12.3,174.6,13.4,174.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.4,246.3h3.8c1.1,0,2,0.9,2,2v41.9c0,1.1-0.9,2-2,2h-3.8c-1.1,0-1.9-0.9-1.9-2v-41.9 C11.4,247.2,12.3,246.3,13.4,246.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.4,318h3.8c1.1,0,2,0.9,2,2v41.9c0,1.1-0.9,2-2,2h-3.8c-1.1,0-1.9-0.9-1.9-2v-41.9 C11.4,318.8,12.3,318,13.4,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.4,389.7h3.8c1.1,0,2,0.9,2,2v41.9c0,1.1-0.9,2-2,2h-3.8c-1.1,0-1.9-0.9-1.9-2v-41.9 C11.4,390.5,12.3,389.7,13.4,389.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.3,31.2h3.8c1.1,0,2,0.9,2,2v41.9c0,1.1-0.9,1.9-2,1.9h-3.8c-1.1,0-2-0.9-2-1.9V33.2 C295.3,32.1,296.2,31.2,297.3,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.3,102.9h3.8c1.1,0,2,0.9,2,1.9v41.9c0,1.1-0.9,1.9-2,1.9h-3.8c-1.1,0-2-0.9-2-1.9v-41.9 C295.3,103.8,296.2,102.9,297.3,102.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.3,174.6h3.8c1.1,0,2,0.9,2,1.9v41.9c0,1.1-0.9,1.9-2,1.9h-3.8c-1.1,0-2-0.9-2-1.9v-41.9 C295.3,175.5,296.2,174.6,297.3,174.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.3,246.3h3.8c1.1,0,2,0.9,2,2v41.9c0,1.1-0.9,2-2,2h-3.8c-1.1,0-2-0.9-2-2v-41.9 C295.3,247.2,296.2,246.3,297.3,246.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.3,318h3.8c1.1,0,2,0.9,2,2v41.9c0,1.1-0.9,2-2,2h-3.8c-1.1,0-2-0.9-2-2v-41.9 C295.3,318.8,296.2,318,297.3,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.3,389.7h3.8c1.1,0,2,0.9,2,2v41.9c0,1.1-0.9,2-2,2h-3.8c-1.1,0-2-0.9-2-2v-41.9 C295.3,390.5,296.2,389.7,297.3,389.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingA);
export default __webpack_public_path__ + "static/media/parking-A.ba871dcb277eb785deb70132573bae1d.svg";
export { ForwardRef as ReactComponent };